import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["type", "soil", "orientation", "samplesInColumns", "column"]

  connect() {
    this.update()
  }

  update() {
    const importType = this.typeTarget.value
    const soil = importType.startsWith("soil_")

    this.soilTargets.forEach(element => { element.hidden = !soil })
    this.columnTargets.forEach(element => {
      const types = (element.dataset.importTypes || "").split(" ")
      element.hidden = importType !== "unknown" && !types.includes(importType)
    })
    this.updateOrientation()
  }

  updateOrientation() {
    const show = this.hasOrientationTarget &&
      this.typeTarget.value.startsWith("soil_") &&
      this.orientationTarget.value === "samples_in_columns"
    this.samplesInColumnsTargets.forEach(element => { element.hidden = !show })
  }
}
